import formatMoney from "lib/formatMoney";
import dayjs from "dayjs";

const CashOfferCalculatorQuestions = [
  {
    q_id: "0",
    q_title: "After repair value (ARV)",
    q_description: (answers) => {
      return "The approximate after repair value of the dwelling.";
    },
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00",
    q_title: "Buyer strategy",
    q_description: (answers) => {
      return "The LTV of the funding the buyer is planning to use";
    },
    a_opts: (answers) => {
      return [
        "65% - Flipper",
        "70% - Flipper",
        "75% - Flipper or Rental",
        "80% - Rental",
      ];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    node_type: "node",
    a_type: "mc",
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "000",
    q_title: "Rehab budget",
    q_description: (answers) => {
      return "The approximate budget of the renovations that will bring the dwelling to ARV.";
    },
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },

  {
    q_id: "0000",
    q_title: "Wholesale fee",
    q_description: (answers) => {
      return "If you plan to assign the contract or double close";
    },
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    node_type: "node",
    a_type: "currency",
    a_input_type: "number",
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter a value above 0",
    a_error: false,
  },
  {
    q_id: "00000",
    q_title: "Calculation name",
    q_description: () => {
      return "What would you like to name this calculation. Ex. 'First option for 777 Happy Choice Rd.' ";
    },
    node_type: "node",
    a_type: "text",
    a_input_type: "text",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "",
    a_error: false,
  },
  {
    q_id: "000000",
    q_title: "Address (optional)",
    q_description: () => {
      return "Enter property address to help organize your calculations. You can also enter a state, zip or nothing, since this field is optional.";
    },
    node_type: "node",
    a_type: "address",
    a_opts: (answers) => {
      return [];
    },
    q_next_step_func: (answer, answers, questions) => {
      return answer.q_id + "0";
    },
    q_child_nodes: [0],
    q_validation_func: (answerVal) => {
      if (answerVal < 0) {
        return false; //isValid
      }
      return true; //isValid
    },
    q_validation_func: (answerVal) => {
      //   make sure not false and a string of none 0 length
      if (!answerVal && !answerVal.length > 0) {
        return false;
      }
      return true; //isValid
    },
    q_invalid_answer_help_text: "Please enter or select an address",
    a_error: false,
  },
];

export default CashOfferCalculatorQuestions;
